import { emptyObj } from 'util/objects'

const selectBase = state => {
  return state.currentUser || emptyObj
}

export default selectBase
